// extracted by mini-css-extract-plugin
export default {"attributeItem":"AttributeItem_attributeItem__RpNjo","label":"AttributeItem_label__WI+4Z","value":"AttributeItem_value__e9K+7"};